module.exports = __webpack_public_path__ + "img/161.572ad73a.png";